import ProductDetailsModal from "./product-detail-modal";

export default ProductDetailsModal;